var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 107,
    viewBox: "0 0 375 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-97 107H410C365.526 -96.4035 263.731 52.6932 263.731 52.6932C257.801 79.353 208.386 35.9075 208.386 35.9075C113.509 -66.7816 137.228 109.962 81.883 77.3781C1.83041 -5.56317 -3.11111 112.924 -46.5965 101.076C-46.5965 101.076 -89.0936 77.3781 -97 107Z",
    fill: "#C8E2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsBg);
export default __webpack_public_path__ + "static/media/clouds-bg.d81bdbe09e70c7e864a68ad505315f39.svg";
export { ForwardRef as ReactComponent };